export var IFramePlayerErrorInfo;
(function (IFramePlayerErrorInfo) {
    IFramePlayerErrorInfo["P1000"] = "utag script load failure!";
    IFramePlayerErrorInfo["P1001"] = "Smart Tag script load failure!";
    IFramePlayerErrorInfo["P1002"] = "Tag creation has failed!";
    IFramePlayerErrorInfo["P1010"] = "Request to get Smart Tag params from DOM has failed!";
    IFramePlayerErrorInfo["P1011"] = "ParamsVO data received from DOM is invalid!";
})(IFramePlayerErrorInfo || (IFramePlayerErrorInfo = {}));
